import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';

export const setUsers = createAction('SET_USERS');
export const setUserDisplayState = createAction('SET_USER_DISPLAY_STATE');
export const resetUserList = createAction('RESET_USER_LIST');
export const setUserPageNumber = createAction('SET_USER_PAGE_NUMBER');
export const setSearchTxt = createAction('SET_USER_SEARCH_STRING');
export const setUserSort = createAction('SET_SORT');
export const setUserSortOrder = createAction('SET_SORT_ORDER');

export const setAccessLevelFilter = createAction('SET_ACCESS_LEVEL_FILTER');
export const setAccountTypeFilter = createAction('SET_ACCOUNT_TYPE_FILTER');
export const setStatusFilter = createAction('SET_ACCOUNT_STATUS_FILTER');
export const setEmpTypeFilter = createAction('SET_EMP_TYPE_FILTER');
export const setOrgFilter = createAction('SET_ORG_FILTER');
export const setLocFilter = createAction('SET_LOC_FILTER');
export const setDeptFilter = createAction('SET_DEPT_FILTER');
export const setRoleFilter = createAction('SET_ROLE_FILTER');
export const setStateFilter = createAction('SET_STATE_FILTER');
export const setYearsOfExperienceFilter = createAction('SET_YEARS_OF_EXPERIENCE_FILTER');
export const setFromDateFilter = createAction('SET_FORM_DATE_FILTER');
export const setToDateFilter = createAction('SET_TO_DATE_FILTER');
export const setorganizations = createAction('SET_ORGANIZATIONS');
export const setLoyaltyFilter = createAction('SET_LOYALTY_FILTER');
export const setSTATCashFilter = createAction('SET_STATCASH_FILTER');
export const setNursePoolTypeFilter = createAction('SET_NURSE_POOL_TYPE_FILTER');
export const setIsImpersonatingLoadingStatus = createAction('SET_IS_IMPERSONTAING_LOADING_STATUS');

const initialState = {
	access_level: {},
	account_status: '',
	account_type: '',
	dept: '',
	display: 'none',
	emp_type: '',
	from_date: '',
	isImpersonatingLoading: false,
	loc: '',
	loyalty_level: '',
	nurse_pool_type: '',
	org: '',
	organizations: [],
	page_no: 1,
	role: '',
	search_string: '',
	sort: 'id',
	sortOrder: 'asc',
	statcash_status: '',
	state: '',
	to_date: '',
	userList: {},
	years_of_experience: ''
};

export default handleActions(
	{
		RESET_USER_LIST: () => initialState,
		SET_ACCESS_LEVEL_FILTER: (state, action) => ({ ...state, access_level: action.payload }),
		SET_ACCOUNT_STATUS_FILTER: (state, action) => ({ ...state, account_status: action.payload }),
		SET_ACCOUNT_TYPE_FILTER: (state, action) => ({ ...state, account_type: action.payload }),
		SET_DEPT_FILTER: (state, action) => ({ ...state, dept: action.payload }),
		SET_EMP_TYPE_FILTER: (state, action) => ({ ...state, emp_type: action.payload }),
		SET_FORM_DATE_FILTER: (state, action) => ({ ...state, from_date: action.payload }),
		SET_IS_IMPERSONTAING_LOADING_STATUS: (state, action) => ({ ...state, isImpersonatingLoading: action.payload }),
		SET_LOC_FILTER: (state, action) => ({ ...state, loc: action.payload }),
		SET_LOYALTY_FILTER: (state, action) => ({ ...state, loyalty_level: action.payload }),
		SET_NURSE_POOL_TYPE_FILTER: (state, action) => ({ ...state, nurse_pool_type: action.payload }),
		SET_ORG_FILTER: (state, action) => ({ ...state, org: action.payload }),
		SET_ORGANIZATIONS: (state, action) => ({ ...state, organizations: action.payload }),
		SET_ROLE_FILTER: (state, action) => ({ ...state, role: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortOrder: action.payload }),
		SET_STATCASH_FILTER: (state, action) => ({ ...state, statcash_status: action.payload }),
		SET_STATE_FILTER: (state, action) => ({ ...state, state: action.payload }),
		SET_TO_DATE_FILTER: (state, action) => ({ ...state, to_date: action.payload }),
		SET_USER_DISPLAY_STATE: (state, action) => ({ ...state, display: action.payload }),
		SET_USER_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_USER_SEARCH_STRING: (state, action) => ({ ...state, search_string: action.payload }),
		SET_USERS: (state, action) => ({ ...state, userList: action.payload }),
		SET_YEARS_OF_EXPERIENCE_FILTER: (state, action) => ({ ...state, years_of_experience: action.payload })
	},
	initialState
);

export const clearAllFilter = () => {
	return function (dispatch) {
		dispatch(setAccessLevelFilter(''));
		dispatch(setAccountTypeFilter(''));
		dispatch(setStatusFilter(''));
		dispatch(setEmpTypeFilter(''));
		dispatch(setOrgFilter(''));
		dispatch(setLocFilter(''));
		dispatch(setDeptFilter(''));
		dispatch(setRoleFilter(''));
		dispatch(setStateFilter(''));
		dispatch(setFromDateFilter(''));
		dispatch(setToDateFilter(''));
		dispatch(setYearsOfExperienceFilter(''));
		dispatch(setLoyaltyFilter(''));
		dispatch(setSTATCashFilter(''));
		dispatch(setNursePoolTypeFilter(''));
	};
};

export const setPageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setUserPageNumber(pageNo));
		dispatch(getUsersWithPaging());
	};
};

export const getUsersWithPaging = () => {
	return function (dispatch, getState) {
		dispatch(setUsers([]));
		dispatch(setUserDisplayState('block'));

		Agent.getUsersWithPaging(getState().userIndex).then((response) => {
			if (response.ok) {
				dispatch(setUsers(response.data));
			} else {
				dispatch(handleError(response));
			}

			dispatch(setUserDisplayState('none'));
		});
	};
};

export const deleteUser = (id) => {
	return function (dispatch) {
		Agent.deleteUserRecord(parseInt(id)).then((response) => {
			if (response.ok) {
				dispatch(getUsersWithPaging());
			} else {
				alert("Couldn't delete selected user", response.data);
			}
		});
	};
};
export const organization = () => {
	return function (dispatch) {
		Agent.organization().then((response) => {
			if (response.ok) {
				response.data.sort(function (a, b) {
					if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
					if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
					return 0;
				});
				dispatch(setorganizations(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
